import { Input } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { hintChildren } from '@/presentation/components/hint-text/hintText';
import styles from '@/presentation/components/tapd/index.module.scss';

export const RenderInput: FC<{
  name: string | null | undefined,
  label: string | null | undefined,
  value: string | number | null | undefined,
  getNewFields: (changeValue: string | number, name?: string | null) => void,
  labelWidth?: string,
}> = ({
  name,
  label,
  value,
  getNewFields,
  labelWidth,
}) => {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', marginBottom: '20px', width: '350px' }}>
      <span className={styles.overflow} style={labelWidth ? { width: labelWidth } : undefined}>
        {hintChildren(label, label)}
      </span>
      <Input
        value={value ?? ''}
        placeholder={t('如有多个值请用;分割')}
        style={{
          width: '200px',
          borderRadius: '3px',
        }}
        onChange={(e: any) => {
          getNewFields(e.target.value, name);
        }}
      />
    </div>
  );
};
